"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Exporter = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _blocks = require("@bueno/blocks");

var _utils = require("./utils");

var _store = require("../../redux/store");

var _tenant = require("../../utils/tenant");

/**
 *
 * Exporter accpets all props from Button,
 *
 * dataFormatter is a custom function as prop that developers create
 * to format the rawData into a format that can be understood by
 * the helper function getCsvBlobUrl from './util'
 * @param props
 *
 */
const Exporter = props => {
  const betaSelections = (0, _store.useAppSelector)(state => state.betaSelections);
  const {
    rawData,
    fileName,
    dataFormatter,
    children,
    exportType,
    ...rest
  } = props;
  const days = betaSelections.daysRange;
  const apertureUrl = (0, _tenant.useApertureUrl)();
  return /*#__PURE__*/React.createElement(_blocks.Button, (0, _extends2.default)({
    thin: true,
    appearance: "subdued",
    icon: /*#__PURE__*/React.createElement(_blocks.Export, {
      small: true,
      fillColor: _blocks.color.theme.typography.subdued
    }),
    onClick: () => (0, _utils.handleCsvExport)(rawData, fileName, dataFormatter, apertureUrl, exportType, days)
  }, rest), children);
};

exports.Exporter = Exporter;